import React, { useCallback, useState } from 'react';
import { editingOptions } from '../../../../constants/app';
import styles from '../../WifiConnect.module.scss';
import { FormattedMessage } from 'react-intl';
import { CompanyDevice } from './CompanyDevicesTable';
import classNames from 'classnames';
import { CompanyDeviceFormState } from '../Forms/CompanyDeviceForm';

interface CompanyDeviceTableRowProps {
  device: CompanyDevice;
  onEdit: (
    mac: string,
    device: CompanyDeviceFormState,
    onCancel?: () => void,
  ) => void;
}

const TeamDeviceTableRow: React.FC<CompanyDeviceTableRowProps> = ({
  device,
  onEdit,
}) => {
  const makeDeviceFormState = useCallback(
    () => ({
      mac: device.mac,
      name: device.name,
      type: editingOptions.includes(device.type)
        ? device.type
        : 'Other device (including ancillary device used for IoT setup)',
      otherType: !editingOptions.includes(device.type) ? device.type : '',
      location: device.location_uuid,
      COMPANY_ID: device.COMPANY_ID,
      COMPANY_NAME: device.COMPANY_NAME,
    }),
    [
      device.mac,
      device.name,
      device.type,
      device.location_uuid,
      device.COMPANY_ID,
      device.COMPANY_NAME,
    ],
  );

  return (
    <tr>
      <td className={styles.tableCol}>{device.name}</td>
      <td className={styles.tableColMac}>{device.mac}</td>
      <td className={styles.tableCol}>
        {editingOptions.includes(device.type) ? (
          <FormattedMessage
            id={`tabs.device.types.${device.type}`}
            defaultMessage={device.type}
          />
        ) : (
          device.type
        )}
      </td>
      {device.is_owner_inactive ? (
        <td
          className={styles.teamDevicesTableCol}
          style={{ verticalAlign: 'middle' }}
        >
          <button
            className={classNames(
              'ray-button ray-button--primary ray-button--compact',
              styles.teamDevicesChangeButton,
            )}
            onClick={() => {
              onEdit(device.mac, makeDeviceFormState());
            }}
          >
            <FormattedMessage
              id="tabs.device.teamDevices.buttons.takeOwnership"
              defaultMessage="Take ownership"
            />
          </button>
        </td>
      ) : (
        <></>
      )}
    </tr>
  );
};

export default TeamDeviceTableRow;
